const REQUIRED_MESSAGE = "Важно! Все поля являются обязательными для заполнения";

export const createErrorMessage = (message: string) => {
    if (message === "Required") {
        return REQUIRED_MESSAGE;
    }

    return message;
};